module.exports = __webpack_public_path__ + "static/media/record-black.42c8bed5.png";